export default "__VITE_ASSET__f4y_HaCZ__"